<template>
  <modal :show.sync="modalOpen" bodyClasses="pt-0 pb-0">
    <h4 slot="header" class="modal-title" id="modal-title-default">Add Player</h4>

    <div class="row" v-if="!showNewPlayerForm">
      <div class="col">
        <base-input
          label="Player"
          :error="errors.player"
        >
          <Multiselect
            v-model="model.player"
            :options="playerSearchOptions"
            class="shadow"
            track-by="id"
            label="Name"
            @search-change="searchUsers"
            :internal-search="false"
          >
            <template slot="option" slot-scope="props">
              <div class="row">
                <div class="col-2">
                  <img class="avatar" :src="getAvatarUrl(props.option)" />
                </div>
                <div class="col-auto">
                  <h4>{{props.option.Name}}</h4>
                  <span class="email">{{props.option.email}}</span>
                </div>
              </div>
            </template>
            <template slot="afterList">
              <div class="new-player-option" @click="showNewPlayerForm = true;">
                + Create New Player
              </div>
            </template>
            <template slot="noResult">
              <div class="pt-1 pb-1">
                No players found.
              </div>
            </template>
            <template slot="noOptions">
              <div class="pt-1 pb-1">
                No players found.
              </div>
            </template>
          </Multiselect>
        </base-input>
      </div>
    </div>
    <div class="row" v-if="showNewPlayerForm">
      <div class="col-12">
        <base-input
          alternative=""
          label="Name"
          placeholder="Name"
          input-classes="form-control-alternative"
          v-model="model.name"
          :error="errors.name"
        />
      </div>
      <div class="col-12">
        <base-input
          alternative=""
          label="Email"
          placeholder="Email"
          input-classes="form-control-alternative"
          v-model="model.email"
          :error="errors.email"
          type="email"
        />
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <label class="form-control-label">
            Avatar Image
          </label>
          <input
            type="file"
            class="form-control form-control-alternative"
            @change="handleFileUpload"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <base-input
          alternative=""
          label="Initial Handicap"
          placeholder="Initial Handicap"
          input-classes="form-control-alternative"
          v-model="model.handicap"
          :error="errors.handicap"
          type="number"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label :class="['form-control-label', {'text-danger': errors.paidInFull !== ''}]">
          Payment Type
        </label><br />
        <PaymentToggle
          v-model="model.paidInFull"
        />
      </div>
      <div class="col-6">
        <label :class="['form-control-label']">
          Toonie Pot
        </label><br />
        <base-switch v-model="model.tooniePot"></base-switch>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="primary"
        @click="addPlayer"
      >
        Add Player
      </base-button>
      <base-button
        type="link"
        class="ml-auto"
        @click="showNewPlayerForm = false; $emit('close');"
      >
        Cancel
      </base-button>
    </template>
  </modal>
</template>
<script>
import Multiselect from 'vue-multiselect';
import Fuse from 'fuse.js';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import AvatarHelper from '@/helpers/Avatars';
import PaymentToggle from '@/components/PaymentToggle.vue';
import ErrorHandler from '@/helpers/AuthError';

export default {
  name: 'AddPlayerModal',
  props: {
    open: Boolean,
    league: Object,
  },
  components: {
    Multiselect,
    PaymentToggle,
  },
  data() {
    return {
      model: {
        player: null,
        name: '',
        email: '',
        paidInFull: '',
        tooniePot: false,
        handicap: 0,
        file: null,
      },
      errors: {
        player: '',
        name: '',
        email: '',
        handicap: '',
        paidInFull: '',
        tooniePot: '',
      },
      showNewPlayerForm: false,
      playerSearchOptions: [],
    };
  },
  mounted() {
    this.$store.dispatch('getPlayers');
  },
  computed: {
    allPlayers() {
      return this.$store.state.players;
    },
    modalOpen: {
      get() {
        return this.open;
      },
      set() {
        this.showNewPlayerForm = false;
        this.$emit('close');
      },
    },
    searchSet() {
      // exclude players in league
      const searchSet = [];
      const leaguePlayerIds = this.league.profiles.map(profile => profile.user);

      this.allPlayers.forEach((player) => {
        if (!leaguePlayerIds.includes(player.id)) {
          searchSet.push(player);
        }
      });

      return searchSet;
    },
  },
  methods: {
    handleFileUpload(e) {
      // eslint-disable-next-line prefer-destructuring
      const files = e.target.files || e.dataTransfer.files;

      if (files.length > 0) {
        const [firstFile] = files;
        this.model.file = firstFile;
      }
    },
    uploadImage() {
      const formData = new FormData();
      formData.append('files', this.model.file);

      return this.axios
        .post('/upload', formData, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        });
    },
    checkForSubmissionErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          this.errors[key] = '';
        }
      });
      if (this.showNewPlayerForm) {
        if (this.model.name === '') {
          this.errors.name = 'This field is required';
        }
        if (this.model.email === '') {
          this.errors.email = 'This field is required';
        }
      } else if (this.model.player === null) {
        this.errors.player = 'This field is required';
      }
      if (this.model.handicap === '' || this.model.handicap === null) {
        this.errors.handicap = 'This field is required';
      }
      if (this.model.paidInFull === '') {
        this.errors.paidInFull = 'Required';
      }
    },
    addPlayer() {
      this.checkForSubmissionErrors();
      let isOk = true;

      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          isOk = false;
        }
      });

      if (!isOk) {
        return;
      }

      if (this.showNewPlayerForm) {
        const uploadJobs = [];
        if (this.$refs.file.files.length > 0) {
          uploadJobs.push(this.uploadImage());
        }
        console.log(uploadJobs);
        Promise.all(uploadJobs)
          .then((response) => {
            const newUser = {
              Name: this.model.name,
              email: this.model.email,
              username: this.model.email,
              confirmed: true,
              password: this.model.email,
            };
            if (response.length > 0) {
              newUser.avatar = response[0].data;
            }

            return this.createUser(newUser);
          })
          .then((response) => {
            this.model.player = response;
            return this.createProfile();
          })
          .then((response) => {
            this.model.name = '';
            this.model.email = '';
            this.model.player = null;
            this.model.handicap = 0;
            this.model.paidInFull = '';
            this.model.tooniePot = false;
            this.showNewPlayerForm = false;
            this.$emit('close');
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.createProfile()
          .then((response) => {
            this.model.name = '';
            this.model.email = '';
            this.model.player = null;
            this.model.handicap = 0;
            this.model.paidInFull = '';
            this.model.tooniePot = false;
            this.showNewPlayerForm = false;
            this.$emit('close');
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    createUser(newUser) {
      console.log(newUser);
      return this.axios
        .post('/users', newUser, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          return response.data;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    createProfile() {
      const newProfile = {
        league: this.league.id,
        user: this.model.player.id,
        handicap: this.model.handicap,
        paidInFull: this.model.paidInFull === 'full',
        paidDeposit: this.model.paidInFull === 'deposit',
        tooniePot: this.model.tooniePot,
      };
      return this.axios
        .post('/profiles', newProfile, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getAvatarUrl(user) {
      return AvatarHelper.getAvatar(user);
    },
    searchUsers(input) {
      if (input === '') {
        this.playerSearchOptions = this.searchSet;
      }
      const options = {
        keys: ['Name', 'email', 'username', 'id'],
      };

      const fuse = new Fuse(this.searchSet, options);

      const result = fuse.search(input);

      this.playerSearchOptions = result;
    },
  },
};
</script>
<style lang="scss">
  .multiselect{
    min-height: 43px;
    box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
    border: 0 !important;
    border-radius: 0.375rem;

    .multiselect__tags{
      min-height: 43px;
      padding-top: 12px;
      border: 0;
      color:#8898aa;
    }

    .multiselect__select{
      padding-top: 13px;
    }
  }
  .avatar{
    object-fit: cover;
  }
</style>
